import React from 'react';
import Footer from '~/Components/Footer';
import { Content, Header } from './styles';

function DivinopolisEmDados() {
	return (
		<>
			<Content>
				<Header>DIVINÓPOLIS EM DADOS</Header>
				<p style={{color:'red'}}><b>Seção temporariamente indisponível</b></p>
			</Content>
			<Footer />
		</>
	);
}

export default DivinopolisEmDados;
